class TextureParser {
	load(url, callback, asset) {
		throw new Error('not implemented');
	}
	open(url, data, device) {
		throw new Error('not implemented');
	}
}

export { TextureParser };
